var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"face-recognition"},[_c('video',{ref:"faceVideo",attrs:{"autoplay":"","muted":"","playsinline":""},domProps:{"muted":true}}),_vm._v(" "),_c('canvas',{ref:"canvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }